import React from "react";
import { styled } from "@mui/system";
import TextButton from "src/components/common/TextButton";

const AlertWrapper = styled("div")(() => ({
  display: "flex",
  alignItems: "center",
  justifyContent: "space-between",
  width: "100%",
  padding: "8px 0px",
  gap: "4px",
  alignSelf: "stretch",
  position: "sticky",
  top: 0,
  backgroundColor: "#FFF",
  zIndex: 1,
}));

const AlertText = styled("div")(() => ({
  display: "flex",
  alignItems: "center",
  gap: "4px",
  alignSelf: "stretch",
  color: "#002035",
  fontFamily: "Söhne",
  fontSize: "12px",
  fontStyle: "normal",
  fontWeight: 400,
  lineHeight: "14px",
}));

interface AlertCircleProps {
  show: boolean;
}
const AlertCircle = styled("div")<AlertCircleProps>(({ show }) => ({
  width: "4px",
  height: "4px",
  borderRadius: "8.889px",
  background: "#FC4C4C",
  display: show ? "inline-flex" : "none",
}));

export interface IButtonProps {
  text: string;
  onClick?: () => void;
}
interface AlertBlockProps {
  text: string;
  buttonProps: IButtonProps;
  showAlert?: boolean;
}
/**
 * Renders an alert block with a text message and an optional button.
 * @param {string} props.text - The text message to display in the alert block.
 * @param {object} props.buttonProps - The properties for the button displayed in the alert block.
 * @param {string} props.buttonProps.text - The text to display on the button.
 * @param {Function} [props.buttonProps.onClick] - The function to execute when the button is clicked. Optional.
 * @param {boolean} [props.showAlert=false] - Indicates whether the alert indicator should be displayed. Defaults to false.
 * @example
 * <AlertBlock
 *   text="Your account has yet to be verified, verify for full access"
 *   buttonProps={{ text: "Verify", onClick: handleVerify }}
 *   showAlert={true}
 * />
 */
const AlertBlock = (props: AlertBlockProps) => {
  const { text, buttonProps, showAlert = false } = props;

  return (
    <AlertWrapper>
      <AlertText>
        <AlertCircle show={showAlert} />
        {text}
      </AlertText>
      {buttonProps.text && (
        <TextButton color="navy" onClick={buttonProps.onClick}>
          {buttonProps.text}
        </TextButton>
      )}
    </AlertWrapper>
  );
};

export default AlertBlock;
